import { AppShell } from '../components/AppShell'
import { useNotifications } from '../lib/api'

function relTime(iso: string): string {
  const now = Date.now()
  const t = new Date(iso).getTime()
  const diff = Math.max(0, now - t)
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  const days = Math.floor(hrs / 24)
  if (days < 7) return `${days}d ago`
  return new Date(iso).toLocaleDateString('en-IE', { month: 'short', day: 'numeric' })
}

export function NotificationsPage() {
  const q = useNotifications()
  const list = q.data ?? []
  const unread = list.filter((n) => !n.readAt).length

  return (
    <AppShell page="notifications" breadcrumb={<span className="topbar__breadcrumb-current">Notifications</span>}>
      <header className="page-header">
        <div className="page-header__main">
          <p className="page-header__eyebrow"><span>Activity</span></p>
          <h1 className="page-header__title">Notifications</h1>
          <p className="page-header__subtitle">
            {unread > 0 ? `${unread} unread · ${list.length} total` : `${list.length} total`}
          </p>
        </div>
      </header>

      <div className="notification-list">
        {q.isLoading && <div style={{ color: 'var(--text-tertiary)', padding: 'var(--space-5)' }}>Loading…</div>}
        {!q.isLoading && list.length === 0 && (
          <div className="empty-state">
            <div className="empty-state__icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <path d="M6 8 a6 6 0 0 1 12 0 c0 7 3 9 3 9 H3 s3 -2 3 -9" />
                <path d="M10 21 a2 2 0 0 0 4 0" />
              </svg>
            </div>
            <h3 className="empty-state__title">You're all caught up</h3>
            <p className="empty-state__body">New notifications will appear here.</p>
          </div>
        )}
        {list.map((n) => (
          <article key={n.id} className={`notification-row ${n.readAt ? '' : 'notification-row--unread'}`}>
            <div className="notification-row__body">
              <h4 className="notification-row__title">{n.title}</h4>
              <p className="notification-row__text">{n.body}</p>
            </div>
            <span className="notification-row__time">{relTime(n.createdAt)}</span>
          </article>
        ))}
      </div>
    </AppShell>
  )
}
